import {
  PositionServiceClient,
  ListPositionRequest,
  GetPositionAccountAllocationRequest,
} from '../proto/reportpb/position_grpc_web_pb';
import { stringToProtoDate } from './ConvertService';
import authSvc from './AuthService';
import { auth } from '../lib/auth/Auth';
import { Pagination } from '../proto/utilspb/pagination_pb';

const service = new PositionServiceClient(window.env.GRPC_ENDPOINT, {}, { ...auth });

export async function listPosition(param, paging) {
  return new Promise((resolve, reject) => {
    let req = new ListPositionRequest();
    req.setFromDate(stringToProtoDate(param.fromDate));
    req.setToDate(stringToProtoDate(param.toDate));
    req.setCorrespondent(param.correspondent);
    req.setBranch(param.branch);
    req.setAccountNo(param.accountNo);
    req.setMasterAccountNo(param.masterAccountNo);
    req.setRep(param.rep);
    req.setAccountName(param.accountName);
    req.setSymbol(param.symbol);
    req.setDateType(param.dateType);

    if (paging) {
      let pg = new Pagination();
      pg.setPageNo(paging.pageNo);
      pg.setPageSize(paging.rowsPerPage);
      pg.setSortName(paging.sortName);
      pg.setSortDirection(paging.sortDirection);
      pg.setFilterNamesList(paging.filterNames);
      pg.setFilterValuesList(paging.filterValues);
      req.setPagination(pg);
    }

    service.listPosition(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function getPositionAccountAllocation(param) {
  return new Promise((resolve, reject) => {
    let req = new GetPositionAccountAllocationRequest();
    req.setType(param);

    service.getPositionAccountAllocation(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}
